export enum topologyUrls {
    wharfs = "topology/wharfs",
    routes = "topology/routes",
    locations = "topology/locations",
    entryOrExit = "topology/locations/entry-exit"
}